import React from 'react';

import { configureErrorTrackerScope } from '../core/setup';
import { getCurrentUser } from '../utils/user';

/**
 * Setup error tracker
 */
export const useErrorTrackerInit = () => {
  React.useEffect(() => {
    const initialiseErrorTracker = async () => {
      const user = await getCurrentUser();
      // Configures the error tracker scope (sentry)
      configureErrorTrackerScope(user);
    };
    initialiseErrorTracker();
  }, []);
};
